import { Redirect, Slot } from "expo-router"
import React from "react"
import { Platform, StyleSheet, View } from "react-native"

import { getAppViewFromState } from "@/base/load-app"
import Appbar from "@/components/Appbar"
import { ChangeFarmAccountDialog } from "@/components/ChangeFarmAccountDialog"
import { ForceUpdateManager } from "@/components/ForceUpdateManager"
import { NewFarmSuccessDialog } from "@/components/NewFarmSuccessDialog"
import { FarmAccountNonPaymentWarningDialog } from "@/components/SubscriptionRenewal"
import { useAppbarPages } from "@/components/dashboard-pages"
import useInitialRoute from "@/hooks/useInitialRoute"
import { useNetworkStatusSync } from "@/hooks/useNetworkStatusSync"
import { useRootSelector } from "@/redux/useRootSelector"
import { testIds } from "@/theme"
import DemoModeIndicator from "@/components/DemoModeIndicator"
import OfflineIndicator from "@/components/OfflineIndicator"

// Legacy tab bar dimensions - kept for backward compatibility
// These are no longer used on native but may be referenced elsewhere
export const TAB_BAR_HEIGHT = 64
export const TAB_BAR_MARGIN = 12

const styles = StyleSheet.create({
  root: { flex: 1 },
})

/**
 * Map-only layout for native apps.
 * The StatusMap is the primary view with all navigation handled via bottom sheets.
 * This replaces the TabNavigator on native platforms.
 */
function MapOnlyLayout() {
  return (
    <View style={styles.root}>
      <Slot />
    </View>
  )
}

function WebDashboardLayout() {
  const pages = useAppbarPages()
  return (
    <View {...testIds("dashboard")} style={styles.root}>
      <Appbar pages={pages} />
      <Slot />
    </View>
  )
}

/**
 * Users must be connected to a farm to use the dashboard.
 * If they are not, they are redirected to the no-farms page.
 */
export default function TabsLayout() {
  useInitialRoute()
  useNetworkStatusSync()
  const appView = useRootSelector(getAppViewFromState)

  if (appView === "noFarms") {
    return <Redirect href={"/no-farms"} />
  }

  return (
    <React.Fragment>
      {Platform.OS === "web" ? <WebDashboardLayout /> : <MapOnlyLayout />}
      <FarmAccountNonPaymentWarningDialog />
      <NewFarmSuccessDialog />
      <ChangeFarmAccountDialog />
      <ForceUpdateManager />
      <OfflineIndicator />
      <DemoModeIndicator IconComponent={"Close"}/>
    </React.Fragment>
  )
}
